import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { analytics } from "@silvertours/front-entities";
var CustomContentModule = function(param) {
    var slug = param.slug;
    var consent = analytics.useConsent();
    if (consent === analytics.CookieConsent.Enabled) {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("iframe", {
                width: "100%",
                src: "https://c0001.m1ca.de/billiger-mietwagen-slotmachine",
                title: slug,
                scrolling: "no",
                style: {
                    width: "100%",
                    height: "50rem",
                    border: "0"
                },
                children: "\xa0"
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        style: {
            overflow: "hidden",
            width: "100%",
            height: "50rem",
            border: "0",
            backgroundColor: "black"
        },
        children: "\xa0"
    });
};
export { CustomContentModule };
